import { Component, Optional, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'dojo-ugl-disclaimers',
    templateUrl: './dojo-ugl-disclaimers.component.html'
})
export class DojoUglDisclaimersComponent {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    realTimeActive: boolean = false;
    isTRP: boolean = false;
    isTradelink: boolean = false;
    constructor(private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
        if (sessionStorage.getItem('realTimeActive')) {
            this.realTimeActive = 'true' === sessionStorage.getItem('realTimeActive');
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        if (appSettings.ibdConfigMap.IBD && appSettings.ibdConfigMap.IBD === '30A') {
            this.isTRP = true;
        }
        if (appSettings.ibdConfigMap.community && appSettings.ibdConfigMap.community === 'tradelink') {
            this.isTradelink = true;
        }
    }

}
